class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    this.heroAnimation();
    this.bnrModal();
    new PriceTab('js-price-table');

    // Hero Swiper
    if (document.querySelector('.js-hero-swiper')) {
      new Swiper('.js-hero-swiper', {
        slidesPerView: 1.5,
        loop: true,
        centeredSlides: true,
        speed: 800,
        loopAdditionalSlides: 10,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
      });
    }

    if (document.querySelector('.js-support-swiper')) {
      new Swiper('.js-support-swiper', {
        loop: true,
        loopAdditionalSlides: 2,
        effect: "cards",
        slidesPerView: 1,
        grabCursor: true,
        speed: 600,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        cardsEffect: {
          rotate: true,
          perSlideRotate: 25,
          perSlideOffset: 35,
        },
      });
    }

    // Flow Swiper
    if (document.querySelector('.js-flow-swiper')) {
      new Swiper('.js-flow-swiper', {
        slidesPerView: 1.25,
        centeredSlides: true,
        speed: 600,
        navigation: {
          nextEl: '.js-flow-next',
          prevEl: '.js-flow-prev',
        },
        pagination: {
          el: '.js-flow-pagination',
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + String(index + 1).padStart(2) + '</span>';
          },
        },
      });
    }

  }

  bnrModal() {
    const modal = document.getElementById('js-bnr-modal');
    if (!modal) return;
    // overflow-clip の祖先要素に clipping されないよう body 直下へ移動
    document.body.appendChild(modal);

    const show = () => {
      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
    };

    const close = () => {
      modal.classList.remove('is-active');
      modal.setAttribute('aria-hidden', 'true');
    };

    setTimeout(show, 3000);
    modal.querySelector('.js-modal-close').addEventListener('click', close);
    modal.querySelector('.js-modal-overlay').addEventListener('click', close);
  }

  heroAnimation() {
    if (!document.querySelector('.js-hero-logo')) return;

    const tl = gsap.timeline();

    // 背景装飾: じわっとフェードイン
    tl.fromTo('.js-hero-bg',
      { opacity: 0 },
      { opacity: 1, duration: 2, ease: 'power1.inOut' },
      0
    )

    // ロゴ: 上から落ちてくる + わずかにバウンス
    .fromTo('.js-hero-logo',
      { opacity: 0, y: -32, scale: 0.88 },
      { opacity: 1, y: 0, scale: 1, duration: 1.1, ease: 'back.out(1.6)' },
      0.3
    )

    // ヒーロースワイパー: 軽くズームアウトしながら出現（シネマティック）
    .fromTo('.js-hero-swiper-wrap',
      { opacity: 0, scale: 1.06, y: 16 },
      { opacity: 1, scale: 1, y: 0, duration: 1.4, ease: 'power3.out' },
      0.6
    )

    // イントロテキスト: 下からせり上がる
    .fromTo('.js-hero-intro',
      { opacity: 0, y: 36 },
      { opacity: 1, y: 0, duration: 1.1, ease: 'power3.out' },
      1.2
    );
  }
}
